import { Outlet, createFileRoute } from '@tanstack/react-router'

import { useFocusNode } from '@/licenses-tree/useFocusNode'

export const Route = createFileRoute(
  '/company/_management/licenses-structure/$nodeId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  // Centering the viewport on the selected node belongs to the node route, not
  // a panel's render: it stays route-driven and also fires on a cold page load.
  const { nodeId } = Route.useParams()
  useFocusNode(nodeId)

  return <Outlet />
}
